import React, { useState } from "react";
import styles from "./Channels.module.scss";
import CustomButton from "../../CustomButton/CustomButton";
import AddChannel from "../../AddChannel/AddChannel";
import AnotherChannelModal from "./AnotherChannelModal/AnotherChannelModal";
import AddTelegramModal from "./AddTelegramModal/AddTelegramModal";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { telegramList } from "../../../api/telegramApi";
import ChannelItem from "./ChannelItem/ChannelItem";
import Input from "../../Input/Input";
import LoadingContainer from "../../LoadingContainer/LoadingContainer";

const Channels = () => {
  const [addChannel, setAddChannel] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const { t } = useTranslation();
  const { data, isLoading } = useQuery({
    queryKey: ["telegramList"],
    queryFn: telegramList,
    staleTime: 5 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });
  const renderModal = () => {
    switch (openModal) {
      case "telegram":
        return <AddTelegramModal setOpenModal={setOpenModal} />;
      case "another":
        return <AnotherChannelModal setOpenModal={setOpenModal} />;
      default:
        return null;
    }
  };

  const channelData = data?.data;

  return (
    <div className={styles.channels}>
      <p className={styles.info}>{t("channels.infoText")}</p>
      <CustomButton blue plus width="200px" onClick={() => setAddChannel(true)}>
        {t("channels.addChannel")}
      </CustomButton>
      {/* <Input search placeholder="" /> */}
      <span className="line"></span>
      {addChannel && (
        <AddChannel setOpenModal={setOpenModal} setAddChannel={setAddChannel} />
      )}
      {isLoading ? (
        <LoadingContainer />
      ) : channelData ? (
        <ChannelItem data={channelData} />
      ) : (
        <div className={styles.noData}>{t("channels.noChannels")}</div>
      )}
      <div></div>
      {renderModal()}
    </div>
  );
};

export default Channels;
